module.exports = __webpack_public_path__ + "static/media/solar-solution.1639b8c1.png";